export const fetchSuspensions = async params => {
  return await window.$vue.$get({
    endpoint: "/suspension/",
    params
  })
}

export const fetchUsersForSuspension = async () => {
  return await window.$vue.$get({
    endpoint: "/user/active-without-suspension"
  })
}

export const createSuspension = async params => {
  return await window.$vue.$post({
    endpoint: "/suspension",
    data: params
  })
}

export const fetchSuspensionDetails = async uuid => {
  return await window.$vue.$get({
    endpoint: `/suspension/${uuid}`
  })
}

export const cancelSuspension = async (uuid, reason) => {
  return await window.$vue.$post({
    endpoint: `/suspension/${uuid}/inactivate`,
    data: {
      reason
    }
  })
}

export const fetchIndicators = async () => {
  return await window.$vue.$get({
    endpoint: "/suspension/indicators"
  })
}

export const fetchSuspensionTypes = async () => {
  return await window.$vue.$get({
    endpoint: "/suspension/suspension-types"
  })
}
